export enum VehicleTypes {
  BUS = 'bus',
  CAR = 'car',
  MOTORCYCLE = 'motorcycle',
  OTHER = 'other',
  SUV = 'suv',
  THREE_WHEELER = 'three_wheeler',
  TROLLEY = 'trolley',
  TRUCK = 'truck',
}

export enum DetectionVehicleTypes {
  CAR = 1,
  TRUCK = 2,
  BUS = 3,
  MOTORCYCLE = 4,
}
